import React from 'react';
import pageStyle from '../StockPage/StockPage.module.css';
import style from './InsiderTrades.module.css';
import InsiderTradesTab from './InsiderTradesTab';
import CongressTradesTab from './CongressTradesTab';
import useInsiderTradings from '../../hooks/useInsiderTradings';
import usePoliticianTransactions from '../../hooks/usePoliticianTransactions';
import {
  shouldShowCongressCard,
  shouldShowInsiderCard,
} from './insiderCongressHydration';

const InsiderTradesContent = ({ stock }) => {
  const { insiderTradings, isLoading: insiderLoading } = useInsiderTradings(stock.id, {
    openMarketOnly: false,
  });
  const { politicianTransactions, isLoading: congressLoading } = usePoliticianTransactions(stock.id);

  const showInsiderCard = shouldShowInsiderCard(true, insiderLoading, insiderTradings);
  const showCongressCard = shouldShowCongressCard(true, congressLoading, politicianTransactions);

  if (!showInsiderCard && !showCongressCard) {
    return null;
  }

  return (
    <div
      className={`${pageStyle.flexGrid} ${style.dualCards}`}
      data-testid="insider-congress-trades"
    >
      {showInsiderCard && (
        <div className={style.card}>
          <h3 className={style.headline}>Insider Trades</h3>
          <InsiderTradesTab stock={stock} />
        </div>
      )}
      {showCongressCard && (
        <div className={style.card}>
          <h3 className={style.headline}>Congress Trades</h3>
          <CongressTradesTab stock={stock} />
        </div>
      )}
    </div>
  );
};

export default InsiderTradesContent;
